import queryString from 'query-string';
import { get, post, del } from './apiUtils';

const defaultUrl = '/CosAnnexesTR/';

export default {
  getCosAnnexeTRList: query => (query ? get(`${defaultUrl}?${queryString.stringify(query)}`) : get(defaultUrl)),
  saveCosAnnexeTR: data => post(`${defaultUrl}`, data),
};
